import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Heading } from '../../Elements/Elements';
import classes from './Donut.module.scss';

const Donut = ({
  donatChartData: { title, valuelabel, values, color },
  className
}) => {
  const defoultValue = {
    size: 128,
    strokewidth: 7
  };

  const arrLabel = valuelabel ? valuelabel.split(' ') : null;
  const halfsize = defoultValue.size * 0.5;
  const radius = halfsize - defoultValue.strokewidth * 0.5;
  const circumference = 2 * Math.PI * radius;
  const strokeval = (values.current * circumference) / values.max;
  const dashval = strokeval + ' ' + circumference;

  const trackstyle = { strokeWidth: defoultValue.strokewidth };
  const indicatorstyle = {
    strokeWidth: defoultValue.strokewidth,
    strokeDasharray: dashval
  };
  const rotateval = 'rotate(-90 ' + halfsize + ',' + halfsize + ')';

  return (
    <section className={cn(classes.box, className)}>
      <Heading>{title}</Heading>
      <div className={classes.chartContainer}>
        <svg
          width={defoultValue.size}
          height={defoultValue.size}
          className={classes.donutchart}
        >
          <circle
            r={radius}
            cx={halfsize}
            cy={halfsize}
            transform={rotateval}
            style={trackstyle}
            className={cn(classes.donutchart_track, classes[color])}
          />
          {values.max !== 0 && values.current !== 0 && (
            <circle
              r={radius}
              cx={halfsize}
              cy={halfsize}
              transform={rotateval}
              style={indicatorstyle}
              className={cn(classes.donutchart_indicator, classes[color])}
            />
          )}

          <text
            x={halfsize}
            y={arrLabel ? halfsize - 5 : halfsize + 7}
            style={{ textAnchor: 'middle' }}
          >
            <tspan className={classes.donutchart_text__val}>
              {values.current}/{values.max}
            </tspan>
            {arrLabel &&
              arrLabel.map((label, ind) => {
                return (
                  <tspan
                    className={classes.donutchart_text__label}
                    x={halfsize}
                    y={halfsize + 16 * (ind + 1)}
                    key={`${valuelabel}-${label}`}
                  >
                    {label}
                  </tspan>
                );
              })}
          </text>
        </svg>
      </div>
    </section>
  );
};

Donut.propTypes = {
  donatChartData: PropTypes.shape({
    valuelabel: PropTypes.string,
    values: PropTypes.shape({
      current: PropTypes.number,
      max: PropTypes.number
    }),
    title: PropTypes.string,
    color: PropTypes.string
  }),
  className: PropTypes.string
};

export default Donut;
